import React from 'react';
import faq_img from '../../../assets/media/home-page/faq-img.jpg';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {gsap} from 'gsap'
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import { Tween } from 'react-gsap';


gsap.registerPlugin(ScrollTrigger);

const Faq = () => {

    const [expanded, setExpanded] = React.useState(1);

    const handleChange = (panel) => (event, isExpanded) => {
      setExpanded(isExpanded ? panel : false);
    };


    return (
        <section id="faq">
            
            <div className="container">
                <div className="col-3 faq-bg-effect">
                    <Faq_bg_effect _scale={.9}/>
                    <Faq_bg_effect _scale={1.1}/>
                </div>

            <Tween
                to={{ 
                    scrollTrigger: {
                        trigger: "#faq .faq_typography_area",
                        start: '100px center',
                    },
                    css : {
                        opacity: 1,
                        y:0
                    }
                }}
            >
                <div className="col-lg-8 ml-auto faq_typography_area">
                    <div className="large-tittle">
                        <h1>FAQs</h1>
                    </div>


                    <Faq_cards
                        expand_F={handleChange}
                        is_expanded={expanded}
                        expane_key= {1}
                    />

                    <Faq_cards
                        expand_F={handleChange}
                        is_expanded={expanded}
                        expane_key= {2}
                    />
                    
                    <Faq_cards
                        expand_F={handleChange}
                        is_expanded={expanded}
                        expane_key= {3}
                    />

                </div>
            </Tween>

            </div>


        </section>
    )
}

export default Faq



const Faq_cards = ({expand_F , is_expanded, expane_key }) => (

    <>
        <Accordion 
            expanded={is_expanded === expane_key} 
            onChange={expand_F(expane_key)}
            className="faq_collapse"
        >
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                >
                <Typography variant="h1">
                    {expane_key}. Curabitur volutpat metus eget hendrerit dapibus ? 
                </Typography>
            </AccordionSummary>

            <AccordionDetails>
                <p className="faq-answer">
                    It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.
                </p>
            </AccordionDetails>
        </Accordion>
    </>
)


const Faq_bg_effect = ({_scale}) => (
    <Tween
        to={{ 
            scrollTrigger: {
                trigger: "#faq .faq-bg-effect",
                start: '0 bottom',
                scrub: true
            },
            css : {
                scale: _scale
            }
        }}
    >
        <img src={faq_img} alt="faq_img"/>
    </Tween>
)